import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';
import { Link } from '@mint/routing';

export const ArchivedVersionNotice = () => {
  const { t } = useTranslation('@myn/planning_v2');

  return (
    <div className="ml-4 flex items-center gap-0.5">
      <p
        className={typographyVariants({
          variant: 'caption1',
          color: 'secondary',
        })}
      >
        {t('This is an archive version.')}
      </p>

      <Link
        to="."
        search={({ flightVersionId: _removed, ...updatedSearch }) =>
          updatedSearch
        }
        className={typographyVariants({
          variant: 'caption1',
          color: 'link',
        })}
      >
        {t('Back to current version')}
      </Link>
    </div>
  );
};
